import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { SvgProvider } from "./context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SvgProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SvgProvider>
  </React.StrictMode>
);
